export default __webpack_public_path__ + "static/media/blue.610f9b44.jpg";